import { render, staticRenderFns } from "./XeroOAth.vue?vue&type=template&id=0ff67fb4&scoped=true&"
import script from "./XeroOAth.vue?vue&type=script&lang=js&"
export * from "./XeroOAth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff67fb4",
  null
  
)

export default component.exports